import { useEffect, useState } from 'react'
import { Dimensions, Platform, StatusBar } from 'react-native'

export function useAndroidNavBarHeight() {
    const [navBarHeight, setNavBarHeight] = useState(0)

    useEffect(() => {
        if (Platform.OS == 'ios') setNavBarHeight(20)
        if (Platform.OS != 'android') return
        const windowHeight = Dimensions.get('window').height
        const screenHeight = Dimensions.get('screen').height

        // Diferencia = área ocupada por nav bar (y a veces status bar)
        const diff = screenHeight - windowHeight - (StatusBar.currentHeight || 0)

        // Evita valores negativos o muy altos
        console.log('Android nav bar height calculated: ====>', diff)
        setNavBarHeight(diff > 0 && diff < 200 ? diff : 0)
    }, [])

    return navBarHeight
}
